import Libphonenumber from "./importHelper";
import UtilsService from "app/services/utils/utils.service";
import AdminService from "external-services/diary-admin-service/admin.service";

const NS = 'PhoneNumberService'; // jshint ignore:line

export const INTERNATIONAL = 'INTERNATIONAL';
export const NATIONAL = 'NATIONAL';

class PhoneNumberService {

  public setup(): void {
    window.libphonenumber = Libphonenumber;
  }

  public formatNumber(phoneNumber: string, countryCode: string = null, checkValidity: boolean = null, type: string = null): string {
    if (!type) {
      type = INTERNATIONAL;
    }

    if (typeof phoneNumber !== 'string') {
      console.warn(NS, `provided 'phoneNumber' argument was not a valid string`, phoneNumber);
      return null;
    }
    const parsedPhoneNumber = window.libphonenumber.parsePhoneNumberFromString(phoneNumber, countryCode);

    if (!parsedPhoneNumber || checkValidity && !parsedPhoneNumber.isValid()) {
      return null;
    }
    return parsedPhoneNumber.format(type);
  }

  public normalizePhoneNumber(phoneNumber: string, format: string): string {
    if (phoneNumber) {
        const venue = AdminService.getVenue();
        phoneNumber = UtilsService.checkPhoneState(phoneNumber, venue.country, venue.state, true);
        return this.formatNumber(phoneNumber, venue.country, true, format);
    }
    return null;
  }
}

const instance = new PhoneNumberService();
export default instance as PhoneNumberService;
